import { createFileRoute } from "@tanstack/react-router";
import { CreateConsentSolution } from "@/features/consent-solutions";

const Route = createFileRoute("/_authorized/consent-solutions/create")({
  component: () => <CreateConsentSolution />,
});

export { Route };
